<template>
	<v-row>
		<BottomNavigationContainer v-if="menu.length > 1" :menu="menu" />

		<v-col cols="12" class="d-none d-md-block">
			<ToolbarContainer :menu="menu" />
			<v-toolbar elevation="1" height="25" rounded="b">
				<Breadcrumbs />
			</v-toolbar>
		</v-col>

		<v-col cols="12" lg="12">
			<router-view />
		</v-col>
	</v-row>
</template>

<script>
import Breadcrumbs from "../Widgets/Breadcrumbs";
import ToolbarContainer from "../Widgets/ToolbarContainer";
import BottomNavigationContainer from "../Widgets/BottomNavigationContainer";

export default {
	name: "CdContainer",
	components: { Breadcrumbs, ToolbarContainer, BottomNavigationContainer },
	data: () => ({
		menu: [],
	}),
	methods: {
		montarMenu() {
			let m = [];

      if (this.permissao("logistica_menu_dash_lotes")) {
        m.push({
          titulo: "Acompanhamento de Lotes",
          titulo_app: "Dash Logistica",
          icon: "mdi-file-document-outline",
          to: "/logistica",
          tooltip: "Dashboard com indicadores da Logistica",
        });
      }

      // if (this.permissao("cd_menu_estoque_reserva_wms")) {
      //   m.push({
      //     titulo: "Conferencia de Remessas",
      //     titulo_app: "Conferencia de Remessas",
      //     icon: "mdi-file-document-outline",
      //     to: "/logistica/conferencia-remessa",
      //     tooltip: "Conferencia de Remessas Recebidas",
      //   });
      // }

			this.menu = m;
		},
	},
	mounted() {
		this.montarMenu();
	},
};
</script>

<style scoped>
</style>